
<template>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.54998 15.408V12.9747C4.54998 12.1663 5.18331 11.4413 6.08331 11.4413C6.89165 11.4413 7.61665 12.0747 7.61665 12.9747V15.3163C7.61665 16.9413 6.26665 18.2913 4.64165 18.2913C3.01665 18.2913 1.66665 16.933 1.66665 15.3163V10.183C1.57498 5.49967 5.27498 1.70801 9.95831 1.70801C14.6416 1.70801 18.3333 5.49967 18.3333 10.0913V15.2247C18.3333 16.8497 16.9833 18.1997 15.3583 18.1997C13.7333 18.1997 12.3833 16.8497 12.3833 15.2247V12.883C12.3833 12.0747 13.0166 11.3497 13.9166 11.3497C14.725 11.3497 15.45 11.983 15.45 12.883V15.408" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
    
  <script>
  export default {
    name: 'SupportIcon',
    props: {
      size: {
        type: [Number, String],
        default: 20,
      },
      isActive: Boolean,
    },
    data() {
      return {
        isHovered: false,
        isClicked: false,
      };
    },
    computed: {
      iconFillColor() {
        if (this.isClicked) return '#222222';
        if (this.isHovered) return '#2F6DF7'; 
        if (this.isActive) return '#222222';
        return '#667085';
      },
    },
  };
  </script>
  